import { SxProps, Theme } from '@mui/material';

export const alertComponentStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  }) as SxProps<Theme>,

  fullPageContainer: () => ({
    paddingTop: '50px',
  }) as SxProps<Theme>,

  alert: (theme: Theme) => ({
    width: '75%',
  }) as SxProps<Theme>,
};

export default alertComponentStyles;
